import { avatar14, img15, img16, img17, img18 } from "../../_components/Imagepath";

export default {
  PaymentData: [
    {
      id: 1,

      image: avatar14,
      name: "Orn LLC",
      email: "orn@example.com",

      totalRevenue: "$2000.00",
      expenses: "$500.00",
      profit: "$1500.00",
    },
    {
      id: 2,

      image: img15,
      name: "Accent Technology",
      email: "accent@example.com",

      totalRevenue: "$1000.00",
      expenses: "$0.00",
      profit: "$1000.00",
    },
    {
      id: 3,

      image: img16,
      name: "Express Advertising",
      email: "express@example.com",

      totalRevenue: "$200.00",
      expenses: "$100.00",
      profit: "$100.00",
    },
    {
      id: 4,

      image: img17,
      name: "Lexicon Technologies",
      email: "lexicon@example.com",

      totalRevenue: "$5000.00",
      expenses: "$1500.00",
      profit: "$3500.00",
    },
    {
      id: 5,

      image: img18,
      name: "Sumo Soft Limited",
      email: "sumo@example.com",

      totalRevenue: "$3000.00",
      expenses: "$1000.00",
      profit: "$2000.00",
    },
  ],
};
